interface Props {
  kicker: string;
  title: string;
  desc?: string;
  center?: boolean;
}

export default function SectionHeading({ kicker, title, desc, center }: Props) {
  return (
    <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""}`}>
      <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
        {kicker}
      </span>
      <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">{title}</h2>
      {desc && <p className={`mt-3 text-sm leading-relaxed text-foreground-600 md:text-base ${center ? "mx-auto" : ""}`}>{desc}</p>}
    </div>
  );
}